import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from "reactstrap";
import { updateLeaveBalance } from "../../Api/ApiUrlConst";

const AdminLeaveBalance: React.FC = () => {
  const [userId, setUserId] = useState("");
  const [leaveTypeId, setLeaveTypeId] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [totalDays, setTotalDays] = useState<number>(0);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");

    try {
      await updateLeaveBalance({
        userId,
        leaveTypeId,
        year,
        newTotalDays: totalDays,
      });

      setMessage("Leave balance updated successfully");
    } catch (err: any) {
      setMessage(err.response?.data || "Update failed");
    }
  };

  return (
    <div className="container mt-4">
      <Card>
        <CardBody>
          <CardTitle tag="h4">Admin Leave Balance</CardTitle>

          {message && <Alert color="info">{message}</Alert>}

          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>User ID</Label>
              <Input value={userId} onChange={(e) => setUserId(e.target.value)} />
            </FormGroup>

            <FormGroup>
              <Label>Leave Type</Label>
              <Input
                type="select"
                value={leaveTypeId}
                onChange={(e) => setLeaveTypeId(Number(e.target.value))}
              >
                <option value={1}>Casual Leave</option>
                <option value={2}>Sick Leave</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label>Year</Label>
              <Input
                type="number"
                value={year}
                onChange={(e) => setYear(Number(e.target.value))}
              />
            </FormGroup>

            <FormGroup>
              <Label>Total Days</Label>
              <Input
                type="number"
                value={totalDays}
                onChange={(e) => setTotalDays(Number(e.target.value))}
              />
            </FormGroup>

            <Button color="primary" type="submit">
              Update Balance
            </Button>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default AdminLeaveBalance;
